import { render, staticRenderFns } from "./SuiviSollicitation.vue?vue&type=template&id=08ecf05c&scoped=true"
import script from "./SuiviSollicitation.vue?vue&type=script&lang=js"
export * from "./SuiviSollicitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecf05c",
  null
  
)

export default component.exports